import * as React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { getConfig } from '@cian/config/browser';
import { ErrorLogComponent } from '@cian/error-log-component';

import { EAlertType } from '../../AuthenticationPopup';
import { IAuthenticationContext } from '@cian/authentication-widget';
import { getLogger } from '@cian/logger/browser';

let container: Element | undefined;

export const closeAuthenticationPopup = () => {
  if (!container) {
    return;
  }

  unmountComponentAtNode(container);
  document.body.removeChild(container);
  container = undefined;
};

export interface IOpenAuthenticationPopupParameters {
  context: IAuthenticationContext;
  alert?: EAlertType;
  onClose?(): void;
}

export async function openAuthenticationPopup({ context, alert, onClose }: IOpenAuthenticationPopupParameters) {
  if (container) {
    return;
  }

  const config = getConfig();
  const logger = getLogger();

  const { AuthenticationPopup } = await import('../../AuthenticationPopup');

  container = document.createElement('div');
  container.setAttribute('data-mark', 'Authentication');
  document.body.appendChild(container);

  const isNewAuth =
    config.get<boolean>('qa.phone.auth.enabled') || config.get<boolean>('phone.authentication.enabled') || false;

  render(
    <ErrorLogComponent logger={logger}>
      <AuthenticationPopup
        userAgent={window.navigator.userAgent}
        isNewAuth={isNewAuth}
        context={context}
        disabledSocials={config.get<string[]>('authentication.disabledSocials') || []}
        alert={alert}
        onClose={() => {
          closeAuthenticationPopup();

          if (onClose) {
            onClose();
          }
        }}
      />
    </ErrorLogComponent>,
    container,
  );
}
